const TURKISH_LOCALE = 'tr-TR';

/**
 * Turkish has a dotted and a dotless `i`, so `toLowerCase()` folds `I` to `i`
 * where Turkish wants `ı`, and `İ` to `i̇`. Every case fold over Turkish text —
 * a donor name, a search term, a sort key — goes through these, and
 * `packages/ui`'s formatters delegate here so there is one implementation.
 */
export function lowerTurkish(value: string): string {
  return value.toLocaleLowerCase(TURKISH_LOCALE);
}

export function upperTurkish(value: string): string {
  return value.toLocaleUpperCase(TURKISH_LOCALE);
}

export function compareTurkish(left: string, right: string): number {
  return left.localeCompare(right, TURKISH_LOCALE);
}
